import React from 'react';
import "./HomePage.css";


function ContactForm() {

  const onSubmit = async (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);

    formData.append("access_key", "83ceaf12-330d-4819-8cc9-a76feb891a4b"); // Enter the access key received through gmail, on which the form's response is to be redirected

    const object = Object.fromEntries(formData);
    const json = JSON.stringify(object);

    const res = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: json
    }).then((res) => res.json());

    if (res.success) {
      alert("Your response has been recorder");
      document.getElementById("user_name").value="";
      document.getElementById("user_email").value="";
      document.getElementById("user_phone").value="";
      document.getElementById("message").value="";
    }
  };

  return (
    <>
    <div className="formMainContainer">
      <div className="formHeadingContainer">
        <h2 className="formHeading">Connect with Our Team of Experts</h2>
        <hr></hr>
      </div>
      <div >
        <form className="formContainer" onSubmit={onSubmit}>
          <label className="nameLabel labelField">Full Name</label>
          <input className="nameInput inputField" type="text" id="user_name" name="user_name" placeholder="Enter your full name" required/>
          <label className="emailLabel labelField">Email Address</label>
          <input className="emailInput inputField" type="email" id="user_email" name="user_email" placeholder="Enter your email" required/>
          <label className="phoneNumberLabel labelField">Phone Number</label>
          <input className="phoneNumberInput inputField" type="telNo" id="user_phone" name="user_phone" placeholder="Enter your phone number"required/>
          <label className="messageLabel labelField">Your message</label>
          <textarea className="formTextarea" id="message" name="message" placeholder="Enter your message"/>
          <button className="formSubmitButton" type="submit">Submit</button>
        </form>
      </div>
    </div>
    
      
    </>
  )
}

export default ContactForm